import classNames from 'classnames/bind';
import type { DynamicObjectInterface, RowsPerPageSelectorProps } from '../../types/propType';
import { useTranslation } from '../../../Translation/TranslationProvider';
import DropDown from '../../../DropDown/DropDown';
import { scrollToTop } from '../Pagination';
import { RowsPerPageSelectorVariant } from '../../types/enums';
import { calculatePaginationUpdate } from '../utils';
import styles from './RowsPerPageSelector.module.scss';

const cx = classNames.bind(styles);

const RowsPerPageSelector = ({
  rowsPerPage,
  pageSizeData,
  currentPage,
  totalRecords,
  startRecordIndex,
  endRecordIndex,
  updatePaginationData,
  scrollToTopRefId,
  variant = RowsPerPageSelectorVariant.DEFAULT,
}: RowsPerPageSelectorProps) => {
  const t = useTranslation();
  const paginationTranslationText = t('nextgen.Table.rowPerPageAndNextPage');

  const handleRowsPerPageChange = (e: DynamicObjectInterface) => {
    const updateData = calculatePaginationUpdate(
      e.rows as number,
      totalRecords,
      currentPage,
      startRecordIndex,
      endRecordIndex,
    );
    updatePaginationData?.(updateData);
    scrollToTop(scrollToTopRefId);
  };

  return (
    <div className={cx('pagination-rows', { compact: variant === RowsPerPageSelectorVariant.COMPACT })}>
      <div className={styles['rows-per-page-dropdown']}>
        <DropDown
          name="rows-per-page-dropdown"
          value={rowsPerPage}
          data={pageSizeData}
          isWithinTable
          data-testid="dropdown-test-id"
          width="27%"
          configData={{
            label: 'rows',
            onSelect: handleRowsPerPageChange,
          }}
          disabledFilter
          isTablePaginationDropdown
          className={styles['dropdown-input']}
        />
      </div>
      <span className={cx('pagination-rows-title')}>{paginationTranslationText}</span>
    </div>
  );
};

export default RowsPerPageSelector;
